<template>
  <div class="mb-3" id="accordionOrderFormsNologin">
    <p>
      <button
        v-for="(el, index) in forms"
        :key="el.target"
        data-bs-toggle="collapse"
        :data-bs-target="`#collapse${el.target}`"
        :aria-controls="`collapse${el.target}`"
        :aria-expanded="index == 0"
        class="btn me-1 mb-1"
        :class="{ collapsed: index != 0, 'btn-outline-info': index != selected, 'btn-info': index == selected }"
        @click="selected = index"
        type="button">
        {{ el.title }}
      </button>
    </p>
    <div
      v-for="(el, index) in forms"
      :key="el.target"
      :id="`collapse${el.target}`"
      :aria-labelledby="`heading${el.target}`"
      class="collapse"
      :class="{ show: index == 0 }"
      data-bs-parent="#accordionOrderFormsNologin">
      <div class="card card-body">
        <h3 class="d-none">{{ el.header }}</h3>
        <component :is="el.component" :csrf="csrf" :position="position" :links="links" :values="values"></component>
      </div>
    </div>
  </div>
</template>

<script>
import orderFormsNologinLogin from './order-forms-nologin-login.vue';
import orderFormsNologinCreate from './order-forms-nologin-create.vue';

export default {
  data: function () {
    return {
      selected: 0,
      forms: [
        {
          component: 'orderFormsNologinLogin',
          title: 'Войти и оформить заказ',
          target: 'Login',
          header: 'Войти на сайт',
          comment: 'войти и потом уже агага!',
        },
        {
          component: 'orderFormsNologinCreate',
          title: 'Новый пользователь',
          target: 'NoLogin',
          header: 'Создать нового пользователя',
          comment: 'новый пользователь тут!',
        },
      ],
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
    values: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    orderFormsNologinCreate,
    orderFormsNologinLogin,
  },
};
</script>
